import * as React from 'react'
// import * as classnames from 'classnames'

import * as styles from './offlineOverlay.css'

import { injectStores, StoreComponent } from '../../store'
import { observer } from 'mobx-react'
import bind from 'bind-decorator'
import { MenuCloseButton } from '../common/elements/buttons'

@injectStores
@observer
export class OfflineOverlay extends StoreComponent {

  @bind
  connectRetry () {
    this.store.appStore.updateOnlineStatus()
    // window.location.reload(true)
  }

  render () {

    return (
      <div className={ styles.overlayContainer }>
        <div className={ styles.offlineText }>Keine Internetverbindung. Einige Inhalte sind nicht verfügbar.</div>
        <div className={ styles.offlineButton }><MenuCloseButton onClick={this.connectRetry}/></div>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/offline/offlineOverlay.tsx